import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	// Default messages (theming only)
	themingTitle: {
		id: 'hub-theming-config-panel.title',
		defaultMessage: 'Theme',
		description: 'Title for the theming configuration panel',
	},
	themingDescription: {
		id: 'hub-theming-config-panel.description',
		defaultMessage: 'Apply color consistently to page elements and other assets.',
		description: 'Description for the theming configuration panel',
	},
	primaryColorTitle: {
		id: 'hub-theming-config-panel.primary-color.title',
		defaultMessage: 'Theme color',
		description: 'Title for the primary color section',
	},
	primaryColorDescription: {
		id: 'hub-theming-config-panel.primary-color.description',
		defaultMessage: 'Changes the default color of page elements.',
		description: 'Description for the primary color section',
	},
	primaryColorPickerTitle: {
		id: 'hub-theming-config-panel.primary-color.picker-title',
		defaultMessage: 'Theme color',
		description: 'Title for the primary color picker',
	},
	themingAffectsTitle: {
		id: 'hub-theming-config-panel.theming-affects.title',
		defaultMessage: 'Changes apply to all pages',
		description: 'Title for the theming affects multiple pages',
	},
	themingAffectsDescription: {
		id: 'hub-theming-config-panel.theming-affects.description',
		defaultMessage: 'View the support site to review how changes were applied.',
		description: 'Description for the theming affects multiple pages',
	},
	supportSiteLink: {
		id: 'hub-theming-config-panel.theming-affects.support-site-link',
		defaultMessage: 'View site',
		description: 'Link text for the support site',
	},
	closeButton: {
		id: 'hub-theming-config-panel.close-button',
		defaultMessage: 'Close theme panel',
		description: 'Accessibility label for the close button',
	},
	// Messages for contexts with branding features available (logo + theming)
	themingTitleWithBranding: {
		id: 'hub-theming-config-panel.title.with-branding',
		defaultMessage: 'Theme and brand',
		description: 'Title for the theming configuration panel when branding features are available',
	},
	themingDescriptionWithBranding: {
		id: 'hub-theming-config-panel.description.with-branding',
		defaultMessage: 'Apply your brand color and logo to create a consistent look across your site.',
		description: 'Description for the theming configuration panel when branding features are available',
	},
	primaryColorTitleWithBranding: {
		id: 'hub-theming-config-panel.primary-color.title.with-branding',
		defaultMessage: 'Brand color',
		description: 'Title for the primary color section when branding features are available',
	},
	primaryColorPickerTitleWithBranding: {
		id: 'hub-theming-config-panel.primary-color.picker-title.with-branding',
		defaultMessage: 'Brand color',
		description: 'Title for the primary color picker when branding features are available',
	},
	themingAffectsDescriptionWithBranding: {
		id: 'hub-theming-config-panel.theming-affects.description.with-branding',
		defaultMessage: 'View the help hub to review how changes were applied.',
		description: 'Description for the theming affects multiple pages when branding features are available',
	},
	supportSiteLinkWithBranding: {
		id: 'hub-theming-config-panel.theming-affects.support-site-link.with-branding',
		defaultMessage: 'View hub',
		description: 'Link text for the support site when branding features are available',
	},
	closeButtonWithBranding: {
		id: 'hub-theming-config-panel.close-button.with-branding',
		defaultMessage: 'Close configuration panel',
		description: 'Accessibility label for the close button when branding features are available',
	},
	overrideAlert: {
		id: 'hub-theming-config-panel.override-alert',
		defaultMessage: 'Theme color changes will not apply to customized elements.',
		description: 'Alert for the override of the Hub primary colour',
	},
	alertDismissButton: {
		id: 'hub-theming-config-panel.override-alert.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Button text to dismiss the override alert notification',
	},
	logoSectionTitle: {
		id: 'hub-theming-config-panel.logo.title',
		defaultMessage: 'Logo',
		description: 'Title for the logo upload section',
	},
	logoSectionDescription: {
		id: 'hub-theming-config-panel.logo.description',
		defaultMessage: 'Upload an image to customize your help center branding.',
		description: 'Description for the logo upload section',
	},
	logoUploadButton: {
		id: 'hub-theming-config-panel.logo.upload-button',
		defaultMessage: 'Upload logo',
		description: 'Button text displayed to initiate logo upload process',
	},
	logoReplaceButton: {
		id: 'hub-theming-config-panel.logo.replace-button',
		defaultMessage: 'Replace',
		description: 'Button text to replace the current logo',
	},
	logoDeleteButton: {
		id: 'hub-theming-config-panel.logo.delete-button',
		defaultMessage: 'Delete',
		description: 'Button text to delete the logo',
	},
	logoUploadError: {
		id: 'hub-theming-config-panel.logo.upload-error',
		defaultMessage: 'We couldn’t upload this image. Try again.',
		description: 'Error message when logo upload fails',
	},
	logoInvalidTypeError: {
		id: 'hub-theming-config-panel.logo.invalid-type-error',
		defaultMessage: 'Invalid file type. Please upload an image (JPG, PNG, SVG, GIF, or WebP).',
		description: 'Error message when uploaded file is not a valid image type',
	},
	logoFileTooLargeError: {
		id: 'hub-theming-config-panel.logo.file-too-large-error',
		defaultMessage: 'File too large. Maximum size is 5MB.',
		description: 'Error message when uploaded file exceeds size limit',
	},
	logoLabel: {
		id: 'hub-theming-config-panel.logo.label',
		defaultMessage: 'Media',
		description: 'Label for the logo upload field',
	},
	deleteLogoButtonText: {
		id: 'hub-theming-config-panel.logo.delete-button-text',
		defaultMessage: 'Delete logo',
		description: 'Accessibility label for the delete logo button',
	},
	logoUploadInstructions:{
		id: 'hub-theming-config-panel.logo.instructions-text',
		defaultMessage: 'Upload an image with a minimum height of {height} for best results',
		description: 'Instructions for logo upload. {height} is the minimum logo height in pixels (e.g., "32px") - the value itself should not be translated',
	},
	logoNavigationBarDescription: {
		id: 'hub-theming-config-panel.logo.navigation-bar-description-text',
		defaultMessage: 'Shows your logo in the top navigation bar.',
		description: 'Description text for logo navigation bar',
	},
	defaultBackgroundImageAltText: {
		id: 'hub-theming-config-panel.logo.default-background-alt',
		defaultMessage: 'Upload placeholder',
		description: 'Alt text for the default background image',
	},
	uploadButtonText: {
		id: 'hub-theming-config-panel.logo.upload-button-text',
		defaultMessage: 'Upload',
		description: 'Text label displayed on the logo upload button',
	},
	logoUploadSuccess: {
		id: 'hub-theming-config-panel.logo.upload-success',
		defaultMessage: 'Logo uploaded successfully',
		description: 'Success message when logo is uploaded',
	},
	logoDeleteSuccess: {
		id: 'hub-theming-config-panel.logo.delete-success',
		defaultMessage: 'Logo deleted successfully',
		description: 'Success message when logo is deleted',
	},
	logoDeletionError:{
		id: 'hub-theming-config-panel.logo.deletion-error-text',
		defaultMessage: "We couldn't delete this image. Try again.",
		description: 'Error message when logo deletion fails',
	}
});
